import { useEffect, useState } from "react";
import SimpleListbox from "../../../../components/input/SimpleListbox";
import {
	CrPromptUsage,
	CrUsageDetails,
	CrPromptUsageKey,
} from "./PromptUsageFilteredByCourseViewModel";
import { promptScoresReportLink } from "./PromptReport";
import { PromptAnalysisChart } from "./PromptAnalysisChart";

const traits = [
	{ value: "averageScore", label: "Average Score", maxValue: 3 },
	{ value: "essayCount", label: "Number of Essays", maxValue: undefined },
	{ value: "draftCount", label: "Number of Drafts", maxValue: undefined },
	{ value: "averageDraftPerEssay", label: "Drafts per Essay", maxValue: undefined },
];

const options = traits.map((t) => ({ value: t.value, label: t.label }));

export function CrPromptAnalysisChart(props: {
	className?: string;
	courseId: number;
	promptData: CrPromptUsage[];
	classData: CrUsageDetails;
}) {
	const getData = (filter: string) => {
		const data = props.promptData.map((data) => {
			const value = data[filter as CrPromptUsageKey];
			return {
				name: data.promptName,
				value: value != null ? Number(value) : null,
				link: promptScoresReportLink(data.promptId, props.courseId),
			};
		});
		return data.find((d) => d.value !== null) ? data : [];
	};

	const [selected, setSelected] = useState(traits[0].value);
	const [label, setLabel] = useState(traits[0].label);
	const [data, setData] = useState(getData(traits[0].value));
	const [maxValue, setMaxValue] = useState(traits[0].maxValue);

	useEffect(() => {
		const trait = traits.find((t) => t.value === selected) ?? traits[0];

		setLabel(trait.label);
		setData(getData(trait.value));
		setMaxValue(trait.maxValue);
	}, [selected]);

	if (!props.promptData || props.promptData.length == 0) return "";

	return (
		<div className={props.className}>
			<SimpleListbox
				id="viewFilter"
				options={options}
				value={selected}
				className="w-1/4"
				onChange={(e) => setSelected(e.target.value)}
			/>

			<PromptAnalysisChart label={label} data={data} maxValue={maxValue} />
		</div>
	);
}
